// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"37ae0af2","72":"d3330773","477":"80690652","627":"2136b5c2","663":"ef831f1b","667":"bd2cfa96","777":"c789e99c","803":"473c625e","820":"b59e20cf"}[chunkId] + ".chunk.js";
};